import { Box, Flex, Text, Avatar, Stack } from "@chakra-ui/react";
// import { useNavigate, useParams } from "react-router-dom";
import {
  newBorder,
  textPrimary,
  textSecondary,
  white,
} from "../../../../../utils/colors";
import dayjs from "dayjs";
// import StatusBadgeNew from "../../../../../components/badges/StatusBadgeNew";
import StatusButtonNew from "../../../../../components/buttons/StatusButtonNew";
// import { TbCake } from "react-icons/tb";
import { useTranslation } from "react-i18next";

const PatientCardMobileAlt = ({ patient, onRowClick }) => {
  const { t } = useTranslation();
  // const navigate = useNavigate();
  // const { slug } = useParams();

  const {
    _id,
    firstName,
    lastName,
    patientID,
    phone,
    birthDate,
    image,
    status,
  } = patient;

  const fullName = `${lastName} ${firstName}`;
  const age = birthDate ? dayjs().diff(dayjs(birthDate), "year") : null;

  const birthDayYear = birthDate ? dayjs(birthDate).format("YYYY") : "-";

  return (
    <Box
      borderRadius="1.5rem"
      bg={white}
      onClick={() => onRowClick(_id)}
      w="100%"
      border={`1px solid ${newBorder}`}
      // boxShadow="sm"
      p="1rem 0rem 1.5rem"
    >
      <Flex
        w="100%"
        align="center"
        justify="space-between"
        mt="0rem"
        p="0 1.5rem"
      >
        <Text fontSize="sm" fontWeight="500" color={textSecondary}>
          {t("patient.patient")}{" "}
          <Text as="span" fontWeight="500" color={textSecondary} ml={0.5}>
            {patientID}
          </Text>
        </Text>
        {/* <StatusButtonNew
          isUnclickable
          currentStatus={status}
          options="patient"
          p={"0 1rem"}
          h="2rem"
        /> */}
      </Flex>
      <Flex w="100%" p="0.5rem 0 0rem">
        <Flex
          w="100%"
          justify="space-between"
          align="center"
          p="0.5rem 1.5rem 0"
        >
          <Flex align="center" gap={2}>
            <Avatar
              name={fullName}
              src={image}
              w="2.25rem"
              h="2.25rem"
              bg={textPrimary}
              color={white}
            />
            <Stack spacing={0} w="100%">
              <Text
                fontSize="1rem"
                fontWeight="500"
                isTruncated
                color={textPrimary}
              >
                {fullName}
              </Text>
              <Flex align="center">
                <Text fontSize="sm" fontWeight="500" color={textSecondary}>
                  {age} {t("patient.yearsOld")}{" "}
                  <Text as="span" fontWeight="300" fontSize="sm" mx={1}>
                    |
                  </Text>{" "}
                  {birthDayYear}
                </Text>

                {patient && patient.phone && patient.phone.length > 4 && (
                  <>
                    <Text
                      fontWeight="300"
                      fontSize="sm"
                      mx={2}
                      color={textSecondary}
                    >
                      |
                    </Text>
                    <Text fontSize="sm" fontWeight="500" color={textSecondary}>
                      {phone}
                    </Text>
                  </>
                )}
              </Flex>
            </Stack>
          </Flex>

          {/* <Text fontSize="sm" fontWeight="600" color={textSecondary}>
            {patientID}
          </Text> */}
        </Flex>
      </Flex>
      {/* <Flex w="100%" borderTop={`1px solid ${newBorder}`} p="1.25rem 0 0">
        <Flex gap="0.5rem" align="center" w="100%" justify="center">
          <Flex spacing={0} w="100%">
            <Flex align="center" w="100%" justify="centers">
              <Text fontSize="sm" fontWeight="500" color={textSecondary}>
                {age} {t("patient.yearsOld")}
              </Text>
              <Text fontWeight="300" fontSize="xs" mx={2} color={textSecondary}>
                |
              </Text>
              <Text fontSize="sm" fontWeight="500" color={textSecondary}>
                {birthDayYear}
              </Text>
              {patient && patient.phone && patient.phone.length > 4 && (
                <>
                  <Text
                    fontWeight="300"
                    fontSize="xs"
                    mx={2}
                    color={textSecondary}
                  >
                    |
                  </Text>
                  <Text fontSize="sm" fontWeight="500" color={textSecondary}>
                    {phone}
                  </Text>
                </>
              )}
            </Flex>
          </Flex>
        </Flex>
      </Flex> */}
      <Flex
        w="100%"
        align="center"
        justify="flex-start"
        mt="1.25rem"
        p="0 1.5rem"
      >
        <StatusButtonNew
          isUnclickable
          currentStatus={status}
          options="patient"
          p={"0 1rem"}
          h="2rem"
        />
      </Flex>
    </Box>
  );
};

export default PatientCardMobileAlt;
